import React, { lazy, useEffect } from "react";
import Hero from "../../Components/landingPage/Hero.jsx";
import { Offer } from "../../Components/landingPage/Offer.jsx";
// import SuccessStats from "../../Components/landingPage/SuccessStats.jsx";
import UpperCarousel from "../../Components/landingPage/UpperCarousel.jsx";
import Layout from "../../Global/Layout.jsx";
import SuccessStories from "../../Components/landingPage/SuccessStories.jsx";
// import Banner from "../../Components/landingPage/Banner.jsx";
import Donatenow from "../../Components/landingPage/Donatenow.jsx";
import { getUserRoleAndStep } from "../auth/PrivateRoute.jsx";
import { useDispatch, useSelector } from "react-redux";
import { setUserRole, setUserStep } from "../../Redux/userSlice.js";
import { FaSpinner } from "react-icons/fa6";
// import SuccessStatCards from "../../Components/successStats/SuccessStatCards.jsx";
const SuccessStatCards = React.lazy(() =>
  import("../../Components/landingPage/successStats/SuccessStatCards.jsx")
);



const LandingPage = () => {


  const images = [
    {
      src: "https://imgs.search.brave.com/0ZaLZ4U0sn4oPlcHHimKgnO3Mcr2nZAUIE7iQU67jgc/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMTEz/OTc3NjY2OC9waG90/by9nZW5lcm91cy1w/ZW9wbGUtaGVscGlu/Zy10by1wb29yLXBl/b3BsZS5qcGc_cz02/MTJ4NjEyJnc9MCZr/PTIwJmM9dlRmX3NN/RVluT1lXYkduT0dQ/YXFMNlRNUFNyRUN4/Uk8yVU5jUGQ4TGkt/VT0",

      // description: 'Description for image 1',
    },
    {
      src: "https://imgs.search.brave.com/_PV27l5vUvgxGBtbq-rdDN4tN3c_9SgYMqnDjkGE0og/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9jZG4u/cGl4YWJheS5jb20v/cGhvdG8vMjAxNi8w/My8xOC8xNS8yMS9o/ZWxwLTEyNjUyMjdf/NjQwLmpwZw",

      // description: 'Description for image 2',
    },
    {
      src: "https://imgs.search.brave.com/stGKa7YE_T7ees1QCnUaOrpVh1NCtoXYuf9vXS82CcY/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMTM2/ODk1ODU2Ni9waG90/by9tYWxlLWFuZC1m/ZW1hbGUtZnJpZW5k/cy1hcnJhbmdpbmct/Zm9vZC1pbi1jYXJk/Ym9hcmQtYm94ZXMu/anBnP3M9NjEyeDYx/MiZ3PTAmaz0yMCZj/PURRb1kxenc1VklU/ODJhSUdTMHZlaDk1/Z3R6bm9KcFl1elpH/bmRRVmFIc1U9",

      // description: 'Description for image 3',
    },
  ];

  const dispatch = useDispatch();

  // useEffect to call getUser once when the component mounts
  useEffect(() => {
    console.log("Component Mounted");
    window.scrollTo(0, 0); // Scroll to the top of the page when component mounts

    getUserRoleAndStep(dispatch); // Call function and pass dispatch
  }, [dispatch]);


  return (
    <div>
      <Layout>
        <Hero />
        <Donatenow />
        <UpperCarousel />
        <React.Suspense fallback={<div><FaSpinner className="animate-spin"/></div>}>
          <SuccessStatCards />
        </React.Suspense>
        <SuccessStories />
        <Offer />
      </Layout>
    </div>
  );
};

export default LandingPage;
